import { selectFinancialYear } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** The fiscal year the cockpit is scoped to: the user's pick, falling back to the global current
 *  fiscal year until one is made. */
export const selectEffectiveCockpitFYear = createSelector(
  [selectFinancialCockpitState, selectFinancialYear],
  ({ selectedFYear }, currentFYear) => selectedFYear ?? currentFYear
)
